export default "__VITE_ASSET__db266d40__$_?nuxt_component=async__"